import Chartist from "chartist";

// Hooks
//
const entryHook = "[js-graph-entry]";
const selectHook = "[js-graph-select]";
// Classes
//

class Widget {
  constructor(element) {
    this.element = element;
    this.widget = element.querySelector('[js-widget-container]');
    this.percentageEle = element.querySelector('[js-widget-percentage]');
    this.priceEle = element.querySelector('[js-widget-price]');
    this.type = element.dataset.type || 'gold';
    this.options = {};
    this.data = {};
    this.percentage = 0;
    this.positive = false;
    this.price = 0;

    this.init()
  }

  async init() {
    const url = `https://rates.wpid.nl/api/${this.type}/graph/hour?currency=EUR&weight_unit=grammes`;
    const res = await fetch(url);
    const json = await res.json();

    const sorted = json.sort((a, b) => {
      return a.time.localeCompare(b.time);
    });

    const sliced = sorted.slice(Math.max(sorted.length - 10, 1))
    const first = sliced[0].bid
    const last = sliced[9].bid

    this.price = last;

    if(first < last) {
      const increase = last - first;
      this.percentage = ((increase / first) * 100).toFixed(2);
      this.positive = true;
    } else {
      const decrease = first - last;
      const percentage = ((decrease / first) * 100).toFixed(2);
      this.percentage = percentage;
      if (percentage == 0.00) this.positive = percentage == 0.00 ? true : false;
    }

    const data = sliced.map(e => e.bid)

    this.data = {
      labels: [''],
      series: [data]
    };

    this.options = {
      showPoint: false,
      showLine: true,
      showArea: false,
      fullWidth: true,
      showLabel: false,
      lineSmooth: false,
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      chartPadding: 0,
    };

    this.createWidget()
  }

  createWidget() {
    new Chartist.Line(this.widget, this.data, this.options);
    this.updatePercentages();
  }

  updatePercentages() {
    this.element.classList[this.positive ? 'remove' : 'add']('widget--red');
    this.percentageEle.innerHTML = `${this.positive ? '+' : '-'}${this.percentage}%`;
    this.priceEle.innerHTML = this.type == 'silver' ? `€${(this.price * 1000).toFixed(2).replace('.', ',')} per kilo` : `€${this.price.toFixed(2).replace('.', ',')} per gram`;
    this.element.classList.add('active');
  }
}

export default Widget;
